/* eslint-disable */
import { IWPTerm, IWPTermRelationship } from "../@types/Wordpress";
import { WpPostEntity } from "../hooks/api/generated";

export function getMetaValue(item: WpPostEntity, key: string): string {
  return item?.wpPostmeta?.find(
    (meta: { [x: string]: string }) => meta?.meta_key === key
  )?.meta_value;
}

export function getTermMetaValue(item: WpPostEntity, key: string): string {
  return item?.termmeta?.find(
    (meta: { [x: string]: string }) => meta?.meta_key === key
  )?.meta_value;
}

export function extractTextAndTruncate(
  htmlString: string,
  maxLength: number
): string {
  if (!htmlString) {
    return "";
  }
  // Strip tags and decode the common HTML entities with a deterministic,
  // SSR-safe approach (no `document`, which is unavailable on the server).
  // Using the same logic on server and client also avoids hydration mismatches.
  const text = htmlString
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, String.fromCharCode(34))
    .replace(/&apos;/g, "'")
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) =>
      String.fromCodePoint(parseInt(hex, 16))
    )
    .replace(/&#(\d+);/g, (_, code) => String.fromCodePoint(Number(code)))
    .replace(/\s+/g, " ")
    .trim();

  if (text.length <= maxLength) {
    return text;
  }
  // Codepoint-aware slice so truncation never splits a surrogate pair.
  return `${Array.from(text).slice(0, maxLength).join("")}...`;
}

export function extractTermRelationshipByType(
  item: WpPostEntity,
  type: string
): IWPTerm[] {
  const terms: IWPTerm[] = [];
  item?.wpTermRelationship?.forEach(
    ({ termTaxonomy: { taxonomy, term } }: IWPTermRelationship) => {
      if (taxonomy === type) {
        terms.push(term);
      }
    }
  );
  return terms;
}
